// import React from 'react';
// import { Controller } from 'react-hook-form';
// import { FormLabel } from './FormLabel';
// import Dropzone from 'react-dropzone-uploader';
// import Swal from 'sweetalert2';
// import { useTranslation } from 'react-i18next';
// import { hasOnlyNormalLetters } from '../../Helpers/regexHelper';

// export const FormDropzone = ({ control, name, id, label, setValue, rules, text, ...props }) => {
//   const { t } = useTranslation();

//   const handleUploadChangeStatus = (fileWithMeta, status) => {
//     const fileName = fileWithMeta.file.name;

//     // Validate file name and handle invalid names before status change
//     if (!hasOnlyNormalLetters(fileName) && status !== 'removed' && status !== 'done') {
//       Swal.fire({
//         title: t('common.INVALID_FILENAME'),
//         confirmButtonText: t('common.OK'),
//         icon: 'warning',
//         text: t('common.INVALID_FILENAME_DESCRIPTION'),
//       });

//       // Avoid calling remove if status is already 'removed'
//       if (status !== 'removed') {
//         fileWithMeta.remove(); // Remove invalid file
//       }
//       return;
//     }

//     if (status === 'done') {
//       setValue(name, fileWithMeta, { shouldValidate: true });
//     } else if (status === 'removed') {
//       setValue(name, null, { shouldValidate: true });
//     }
//   };

//   const renderInputContent = (text, rules) => (
//     <>
//       {rules?.required && <span className="text-danger">*</span>}&nbsp;{text}
//     </>
//   );

//   return (
//     <div>
//       {label && <FormLabel rules={rules} label={label} id={id} />}
//       <Controller
//         name={name}
//         control={control}
//         rules={rules}
//         render={({ field, fieldState }) => (
//           <>
//             <Dropzone
//               id={id}
//               onChangeStatus={(fileWithMeta, status) => {
//                 handleUploadChangeStatus(fileWithMeta, status);
//               }}
//               maxFiles={1}
//               inputContent={renderInputContent(text, rules)}
//               styles={{
//                 dropzone: { minHeight: 100, maxHeight: 100 },
//                 inputLabel: { color: 'gray' },
//               }}
//             />
//             {fieldState.invalid && <div className="text-danger">{fieldState.error?.message}</div>}
//           </>
//         )}
//       />
//     </div>
//   );
// };

// export default FormDropzone;
import React, { useRef } from 'react';
import { Controller } from 'react-hook-form';
import { FormLabel } from './FormLabel';
import Dropzone from 'react-dropzone-uploader';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { hasOnlyNormalLetters } from '../../Helpers/regexHelper';

export const FormDropzone = ({ control, name, id, label, setValue, rules, text, ...props }) => {
  const { t } = useTranslation();
  const invalidFilesRef = useRef(new Set());

  const handleUploadChangeStatus = (fileWithMeta, status) => {
    const fileName = fileWithMeta.file.name;
    const fileId = fileWithMeta.meta.id; // Unique ID for the file

    if (!hasOnlyNormalLetters(fileName) && status !== 'removed' && status !== 'done') {
      Swal.fire({
        title: t('common.INVALID_FILENAME'),
        confirmButtonText: t('common.OK'),
        icon: 'warning',
        text: t('common.INVALID_FILENAME_DESCRIPTION'),
      });

      // Track this file as invalid to skip setting it later
      invalidFilesRef.current.add(fileId);

      if (status !== 'removed') {
        fileWithMeta.remove();
      }
      return;
    }

    // Skip setting value if file is invalid
    if (invalidFilesRef.current.has(fileId)) {
      return;
    }

    if (status === 'done') {
      setValue(name, fileWithMeta, { shouldValidate: true });
    } else if (status === 'removed') {
      setValue(name, null, { shouldValidate: true });
      invalidFilesRef.current.delete(fileId); // Clean up invalid file ref if it was tracked
    }
  };

  const renderInputContent = (text, rules) => (
    <>
      {rules?.required && <span className="text-danger">*</span>}&nbsp;{text}
    </>
  );

  return (
    <div>
      {label && <FormLabel rules={rules} label={label} id={id} />}
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <>
            <Dropzone
              id={id}
              onChangeStatus={handleUploadChangeStatus}
              maxFiles={1}
              inputContent={renderInputContent(text, rules)}
              styles={{
                dropzone: { minHeight: 100, maxHeight: 100 },
                inputLabel: { color: 'gray' },
              }}
            />
            {fieldState.invalid && <div className="text-danger">{fieldState.error?.message}</div>}
          </>
        )}
      />
    </div>
  );
};

export default FormDropzone;
